module.exports = __webpack_public_path__ + "static/media/LogoCorner.fd51b84c.png";